export default __webpack_public_path__ + "static/media/kitchen4-afterD-2048w.7568e113.avif";